<template>
  <div class="modern-enroll-page">
    <div class="carousel-section">
      <carousel></carousel>
    </div>

    <v-container class="enroll-container">
      <div class="page-header">
        <h1 class="page-title">
          <v-icon color="#667eea" size="28" class="mr-2">mdi-star-circle</v-icon>
          Membership Enrollment
          <v-icon color="#764ba2" size="28" class="ml-2">mdi-star-circle</v-icon>
        </h1>
        <p class="page-subtitle">
          <v-icon small color="#8ebf42" class="mr-1">mdi-heart</v-icon>
          Join our vibrant Tamil community and enjoy exclusive benefits
        </p>
      </div>

      <v-row class="content-row">
        <v-col cols="12" md="6">
          <div class="modern-benefits-card">
            <div class="card-header">
              <div class="header-icon">
                <v-icon color="white" size="28">mdi-star-circle</v-icon>
              </div>
              <h2 class="card-title">Member Benefits</h2>
            </div>

            <div class="benefits-list">
              <div class="benefit-item">
                <div class="benefit-icon purple">
                  <v-icon color="white" size="20">mdi-calendar-star</v-icon>
                </div>
                <div class="benefit-content">
                  <h3 class="benefit-title">Exclusive Events Access</h3>
                  <ul class="benefit-details">
                    <li><strong>Pongal Vizha</strong> Showcase your/kids talent during the event</li>
                    <li>Participate and Win Prizes in competitions</li>
                    <li><strong>Chithirai Thiruvizha</strong> Cultural events Tamil Traditional Feast</li>
                    <li><strong>Kodai Kondattam</strong> Summer Celebration exclusively for Members</li>
                  </ul>
                </div>
              </div>

              <div class="benefit-item">
                <div class="benefit-icon blue">
                  <v-icon color="white" size="20">mdi-account-group</v-icon>
                </div>
                <div class="benefit-content">
                  <h3 class="benefit-title">Youth Committee</h3>
                  <ul class="benefit-details">
                    <li>Members children eligible for Youth run events and programs</li>
                    <li>Multiple Volunteering Opportunities</li>
                  </ul>
                </div>
              </div>

              <div class="benefit-item">
                <div class="benefit-icon green">
                  <v-icon color="white" size="20">mdi-book-open-variant</v-icon>
                </div>
                <div class="benefit-content">
                  <h3 class="benefit-title">Ilakkiya Vattam Literary Circle</h3>
                  <ul class="benefit-details">
                    <li>Participate in Ilakkiya vattam and immerse yourself in Tamil Literature</li>
                  </ul>
                </div>
              </div>

              <div class="benefit-item">
                <div class="benefit-icon orange">
                  <v-icon color="white" size="20">mdi-hand-heart</v-icon>
                </div>
                <div class="benefit-content">
                  <h3 class="benefit-title">Giveback to Community</h3>
                  <ul class="benefit-details">
                    <li>Volunteering Opportunities in multiple areas to serve the community</li>
                    <li>Volunteers recognized with Awards meeting certain criteria</li>
                  </ul>
                </div>
              </div>

              <div class="benefit-item">
                <div class="benefit-icon teal">
                  <v-icon color="white" size="20">mdi-ticket-percent</v-icon>
                </div>
                <div class="benefit-content">
                  <h3 class="benefit-title">FeTNA Organized Events</h3>
                  <ul class="benefit-details">
                    <li><strong>TefCon</strong> Tamil Entrepreneurs Forum</li>
                    <li><strong>Loving Hearts</strong> Matrimony with Discounted Pricing</li>
                    <li>Discounted Pricing in FetNA organized events and Competitions</li>
                    <li>Many other Events with Celebrities</li>
                  </ul>
                </div>
              </div>

              <div class="benefit-item">
                <div class="benefit-icon indigo">
                  <v-icon color="white" size="20">mdi-certificate</v-icon>
                </div>
                <div class="benefit-content">
                  <h3 class="benefit-title">Tax Deductible Donations</h3>
                  <ul class="benefit-details">
                    <li>Charlotte Tamil Sangam is 501(C)(3) Organization</li>
                    <li>Donations to Sangam are tax deductible</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="6">
          <div class="modern-info-card">
            <div class="card-header">
              <div class="header-icon">
                <v-icon color="white" size="28">mdi-information</v-icon>
              </div>
              <h2 class="card-title">How to Join</h2>
            </div>

            <div class="info-sections">
              <div class="info-section">
                <div class="section-badge new-member">
                  <v-icon small color="white" class="mr-1">mdi-account-plus</v-icon>
                  <span>New Members</span>
                </div>
                <ol class="steps-list">
                  <li>Register Membership</li>
                  <li>Create account sign up</li>
                  <li>Update your profile</li>
                  <li>Pay your membership due</li>
                  <li>Manage your membership online</li>
                </ol>
              </div>



              <div class="info-section">
                <div class="section-badge existing-member">
                  <v-icon small color="white" class="mr-1">mdi-account-check</v-icon>
                  <span>Existing Members</span>
                </div>
                <ol class="steps-list">
                  <li>Sign in with your primary email address</li>
                  <li>Use the password sent to your email or reset if needed</li>
                  <li>Update your profile</li>
                  <li>Manage your membership online</li>
                </ol>
              </div>

              <div class="membership-info">
                <div class="info-badge">
                  <v-icon small color="#8ebf42" class="mr-1">mdi-calendar-clock</v-icon>
                  <span>All memberships are for one year (Jan 1 - Dec 31)</span>
                </div>
              </div>

              <div class="membership-tiers">
                <div class="tier-card paari">
                  <div class="tier-icon">
                    <v-icon color="white" size="24">mdi-crown</v-icon>
                  </div>
                  <h4 class="tier-name">Paari Vallal</h4>
                  <div class="tier-price">$80/year</div>
                  <p class="tier-desc">Highly donated family membership with all benefits</p>
                </div>

                <div class="tier-card family">
                  <div class="tier-icon">
                    <v-icon color="white" size="24">mdi-account-multiple</v-icon>
                  </div>
                  <h4 class="tier-name">Family</h4>
                  <div class="tier-price">$50/year</div>
                  <p class="tier-desc">Husband, wife, dependent children and parents</p>
                </div>

                <div class="tier-card single">
                  <div class="tier-icon">
                    <v-icon color="white" size="24">mdi-account</v-icon>
                  </div>
                  <h4 class="tier-name">Single</h4>
                  <div class="tier-price">$25/year</div>
                  <p class="tier-desc">Youth between ages 18-25 with Valid ID</p>
                </div>
              </div>

              <div class="upgrade-section">
                <div class="upgrade-badge">
                  <v-icon small color="white" class="mr-1">mdi-arrow-up-circle</v-icon>
                  <span>Membership Upgrade</span>
                </div>
                <p class="upgrade-text">
                  Already paid your membership? Upgrade to Paari Vallal for $30.
                  Login and go to your profile page to upgrade automatically.
                </p>
              </div>

              <div class="action-button-wrapper">
                <v-btn
                  class="register-btn"
                  elevation="0"
                  large
                  @click="register()"
                >
                  <v-icon left>mdi-account-multiple</v-icon>
                  Register Now
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div class="sponsors-section">
      <home-images></home-images>
    </div>

    <extended-footer></extended-footer>
  </div>
</template>

<script>
import ReportServices from '@/services/ReportServices'
import ExtendedFooter from '@/components/Footer'
import HomeImages from '@/components/HomePageImages'
import Carousel from '@/components/Carousel'

export default {
  data: () => ({
    errorMessage: false,
    valid: true,
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 25) || 'Name must be less than 25 characters',
    ],
    phoneRules: [
      v => !!v || 'Ph is required',
      v => (v && v.length <= 10) || 'Number must be less than 11 characters',
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    form: false,
    Json: {
      _id: '',
      firstname: '',
      lastname: '',
      primaryemail: '',
      mobile: '',
      address: '',
      state: '',
      city: '',
      membershipcategory: '',
      paymentstatus: 'Not Paid',
      year: '2024'
    },
  }),
  components: {
    ExtendedFooter,
    HomeImages,
    Carousel
  },
  methods: {
    register() {
      this.$router.replace('/Register')
    },
    async submit() {
      if (this.$refs.form.validate()) {
        const response = await ReportServices.addmembership(this.Json)
        if (response.status == 202) {
          this.errorMessage = true
        } else {
          setTimeout(() => {
            this.$router.push('/ThankYou')
          }, 200)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.modern-enroll-page {
  background: linear-gradient(135deg, #fdfeff 0%, #f0f4f8 50%, #e8f0f7 100%);
  min-height: 100vh;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
      radial-gradient(circle at 20% 30%, rgba(102, 126, 234, 0.08) 0%, transparent 50%),
      radial-gradient(circle at 80% 70%, rgba(118, 75, 162, 0.08) 0%, transparent 50%),
      radial-gradient(circle at 50% 50%, rgba(33, 150, 243, 0.05) 0%, transparent 50%);
    pointer-events: none;
  }
}

.carousel-section {
  margin-bottom: 0;
}

.enroll-container {
  max-width: 100%;
  padding: 14px 16px;
  position: relative;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    width: 96%;
    height: 100%;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.6) 0%, rgba(240, 248, 255, 0.4) 100%);
    border-radius: 32px;
    box-shadow:
      0 8px 32px rgba(102, 126, 234, 0.12),
      0 2px 8px rgba(0, 0, 0, 0.04),
      inset 0 1px 0 rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(20px);
    z-index: -1;
    border: 1px solid rgba(255, 255, 255, 0.9);
  }
}

/* Page Header */
.page-header {
  text-align: center;
  margin-bottom: 24px;
  position: relative;
  padding: 18px 20px;
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 252, 255, 0.9) 50%,
    rgba(240, 248, 255, 0.95) 100%);
  border-radius: 20px;
  box-shadow:
    0 8px 24px rgba(102, 126, 234, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 1),
    inset 0 -1px 0 rgba(102, 126, 234, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.9);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.6) 50%,
      transparent 100%);
    animation: shine 3s infinite;
  }
}

@keyframes shine {
  0% { left: -100%; }
  50%, 100% { left: 100%; }
}

.header-icon-wrapper {
  width: 48px;
  height: 48px;
  margin: 0 auto 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 8px 20px rgba(102, 126, 234, 0.3),
    0 2px 8px rgba(118, 75, 162, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, transparent 100%);
    border-radius: 50%;
    z-index: -1;
  }
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

.page-subtitle {
  font-size: 14px;
  color: #475569;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

.content-row {
  margin-top: 0;
}

/* Modern Benefits Card */
.modern-benefits-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.98) 100%);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  height: 100%;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.8);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #667eea 100%);
    background-size: 200% 100%;
    animation: gradientFlow 3s ease infinite;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  }
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(241, 245, 249, 0.8);
}

.header-icon {
  width: 42px;
  height: 42px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.card-title {
  font-size: 19px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

/* Benefits List */
.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.benefit-item {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  &:hover {
    transform: translateX(8px);
    border-color: #667eea;
    background: white;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.15);
  }
}

.benefit-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  &.purple { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
  &.blue { background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%); }
  &.green { background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%); }
  &.orange { background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%); }
  &.teal { background: linear-gradient(135deg, #00BCD4 0%, #0097A7 100%); }
  &.indigo { background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%); }
}

.benefit-content {
  flex: 1;
}

.benefit-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
}

.benefit-details {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    font-size: 13px;
    color: #64748b;
    padding: 3px 0;
    padding-left: 18px;
    position: relative;

    &::before {
      content: '✓';
      position: absolute;
      left: 0;
      color: #8ebf42;
      font-weight: bold;
    }

    strong {
      color: #1e293b;
      font-weight: 600;
    }
  }
}

/* Modern Info Card */
.modern-info-card {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(240, 248, 255, 0.95) 50%,
    rgba(232, 245, 255, 0.98) 100%);
  border-radius: 20px;
  padding: 22px;
  box-shadow:
    0 8px 24px rgba(33, 150, 243, 0.08),
    0 2px 8px rgba(0, 0, 0, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 1),
    inset 0 -1px 0 rgba(33, 150, 243, 0.05);
  height: 100%;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.9);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg,
      #2196F3 0%,
      #1976D2 25%,
      #2196F3 50%,
      #1976D2 75%,
      #2196F3 100%);
    background-size: 200% 100%;
    animation: gradientFlow 4s ease infinite;
    box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 50% 0%, rgba(33, 150, 243, 0.03) 0%, transparent 70%);
    pointer-events: none;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow:
      0 12px 32px rgba(33, 150, 243, 0.12),
      0 4px 12px rgba(0, 0, 0, 0.06),
      inset 0 1px 0 rgba(255, 255, 255, 1);
  }
}

.info-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-section {
  padding: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px;
  border: 2px solid #e2e8f0;
}

.section-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 12px;

  &.new-member {
    background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
    color: white;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  }

  &.existing-member {
    background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
    color: white;
    box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
  }
}

.steps-list {
  margin: 0;
  padding-left: 20px;

  li {
    font-size: 13px;
    color: #475569;
    padding: 4px 0;
    font-weight: 500;
  }
}

.membership-info {
  padding: 12px 16px;
  background: linear-gradient(135deg, #fff9e6 0%, #fff3cc 100%);
  border-radius: 10px;
  border-left: 4px solid #8ebf42;
}

.info-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #1e293b;
  font-weight: 600;
}

/* Membership Tiers */
.membership-tiers {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tier-card {
  padding: 16px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    opacity: 0.1;
    z-index: 0;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }

  &.paari {
    background: linear-gradient(135deg, #fff5f5 0%, #ffe5e5 100%);
    border-color: #FFD700;

    &::before { background: linear-gradient(135deg, #FFD700 0%, #FFC700 100%); }
  }

  &.family {
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    border-color: #2196F3;

    &::before { background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%); }
  }

  &.single {
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
    border-color: #4CAF50;

    &::before { background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%); }
  }
}

.tier-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;

  .paari & { background: linear-gradient(135deg, #FFD700 0%, #FFC700 100%); }
  .family & { background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%); }
  .single & { background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%); }
}

.tier-name {
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
  position: relative;
  z-index: 1;
}

.tier-price {
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 6px;
  position: relative;
  z-index: 1;

  .paari & { color: #FFD700; }
  .family & { color: #2196F3; }
  .single & { color: #4CAF50; }
}

.tier-desc {
  font-size: 13px;
  color: #64748b;
  margin: 0;
  position: relative;
  z-index: 1;
}

/* Upgrade Section */
.upgrade-section {
  padding: 16px;
  background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%);
  border-radius: 12px;
  border: 2px solid #9C27B0;
}

.upgrade-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 10px;
  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(156, 39, 176, 0.3);
}

.upgrade-text {
  font-size: 13px;
  color: #475569;
  margin: 0;
  line-height: 1.5;
}

/* Register Button */
.action-button-wrapper {
  margin-top: 20px;
  text-align: center;
}

.register-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  padding: 18px 40px !important;
  border-radius: 12px !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4) !important;
  transition: all 0.3s ease !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(102, 126, 234, 0.5) !important;
  }

  .v-icon {
    font-size: 20px !important;
  }
}

/* Sponsors Section */
.sponsors-section {
  margin-top: 0;
}

/* Animations */
@keyframes gradientFlow {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

@keyframes glow {
  0%, 100% {
    box-shadow:
      0 8px 24px rgba(102, 126, 234, 0.08),
      0 2px 8px rgba(0, 0, 0, 0.04);
  }
  50% {
    box-shadow:
      0 12px 32px rgba(102, 126, 234, 0.15),
      0 4px 12px rgba(0, 0, 0, 0.06);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .enroll-container {
    padding: 16px 10px;
  }

  .page-header {
    margin-bottom: 16px;
    padding: 14px 16px;
  }

  .header-icon-wrapper {
    width: 42px;
    height: 42px;
    margin-bottom: 8px;
  }

  .header-icon-wrapper .v-icon {
    font-size: 26px !important;
  }

  .page-title {
    font-size: 20px;
    margin-bottom: 4px;
  }

  .page-title .v-icon {
    font-size: 22px !important;
  }

  .page-subtitle {
    font-size: 12px;
  }

  .modern-benefits-card,
  .modern-info-card {
    margin-bottom: 16px;
    padding: 16px;
  }

  .card-title {
    font-size: 17px;
  }

  .benefit-item {
    padding: 12px;
  }

  .benefit-title {
    font-size: 14px;
  }

  .tier-price {
    font-size: 20px;
  }
}

@media (max-width: 600px) {
  .enroll-container {
    padding: 14px 8px;
  }

  .page-header {
    margin-bottom: 14px;
    padding: 12px 14px;
    border-radius: 16px;
  }

  .header-icon-wrapper {
    width: 40px;
    height: 40px;
    margin-bottom: 6px;
  }

  .header-icon-wrapper .v-icon {
    font-size: 22px !important;
  }

  .page-title {
    font-size: 18px;
    margin-bottom: 4px;
    flex-wrap: wrap;
  }

  .page-title .v-icon {
    font-size: 20px !important;
  }

  .page-subtitle {
    font-size: 11px;
    flex-wrap: wrap;
  }

  .modern-benefits-card,
  .modern-info-card {
    padding: 16px;
    border-radius: 14px;
    margin-bottom: 14px;
  }

  .card-header {
    gap: 8px;
    margin-bottom: 12px;
    padding-bottom: 10px;
  }

  .header-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
  }

  .header-icon .v-icon {
    font-size: 20px !important;
  }

  .card-title {
    font-size: 16px;
  }

  .benefits-list {
    gap: 12px;
  }

  .benefit-item {
    padding: 12px;
    gap: 10px;

    &:hover {
      transform: translateX(0);
      transform: translateY(-2px);
    }
  }

  .benefit-icon {
    width: 36px;
    height: 36px;
  }

  .benefit-icon .v-icon {
    font-size: 18px !important;
  }

  .benefit-title {
    font-size: 14px;
    margin-bottom: 4px;
  }

  .benefit-details li {
    font-size: 12px;
    padding: 2px 0;
    padding-left: 16px;
  }

  .info-sections {
    gap: 12px;
  }

  .info-section {
    padding: 14px;
  }

  .section-badge {
    font-size: 11px;
    padding: 5px 10px;
    margin-bottom: 10px;
  }

  .steps-list {
    padding-left: 18px;
  }

  .steps-list li {
    font-size: 12px;
    padding: 3px 0;
  }

  .membership-info {
    padding: 10px 14px;
  }

  .info-badge {
    font-size: 12px;
  }

  .membership-tiers {
    gap: 10px;
  }

  .tier-card {
    padding: 14px;
  }

  .tier-icon {
    width: 36px;
    height: 36px;
    margin-bottom: 8px;
  }

  .tier-icon .v-icon {
    font-size: 20px !important;
  }

  .tier-name {
    font-size: 16px;
    margin-bottom: 4px;
  }

  .tier-price {
    font-size: 20px;
    margin-bottom: 4px;
  }

  .tier-desc {
    font-size: 12px;
  }

  .upgrade-section {
    padding: 14px;
  }

  .upgrade-badge {
    font-size: 11px;
    padding: 5px 10px;
    margin-bottom: 8px;
  }

  .upgrade-text {
    font-size: 12px;
  }

  .action-button-wrapper {
    margin-top: 16px;
  }

  .register-btn {
    font-size: 15px !important;
    padding: 16px 32px !important;
    width: 100%;
  }

  .register-btn .v-icon {
    font-size: 18px !important;
  }
}
</style>
